export enum ThumbnailState {
  PROCESSING = 'processing',
  FAILED = 'failed',
  READY = 'ready',
}
